import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";

import { ActionButton } from "components/ActionButton";
import { DatePicker } from "components/html/Input/DatePicker";
import { GroupingBox } from "components/utility/GroupingBox";
import { HoverHelp } from "components/utility/HoverHelp";

import { i18n } from "services/i18nService";
import { updateHistoricalCosts } from "services/sosInventoryService/sosApi";
import { calendarFormat } from "services/utility/dates";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

export function UpdateHistoricalCosts() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loading.list);

  const [date, setDate] = useState(new Date());

  async function handleUpdateHistoricalCosts() {
    dispatch(loadingIndicatorOn());

    const { success } = await updateHistoricalCosts(calendarFormat(date));
    if (success) {
      const message = i18n("dataUtilities.UpdateHistoricalCostsStarted");
      dispatch(openAlert({ type: "success", message }));
    }
    dispatch(loadingIndicatorOff());
  }

  return (
    <GroupingBox
      width="420px"
      variant="borderLabelMedium"
      heading={i18n("dataUtilities.UpdateHistoricalCosts")}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
        <ActionButton
          sx={{ width: "8rem" }}
          onClick={handleUpdateHistoricalCosts}
          disabled={isLoading}
        >
          {i18n("dataUtilities.BeginUpdate")}
        </ActionButton>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <DatePicker
            name="date"
            label={i18n("dataUtilities.StartingOn")}
            value={date}
            onValueChange={(_, date) => setDate(date)}
            textSx={{ minWidth: "14rem" }}
          />

          <HoverHelp title={i18n("dataUtilities.BeginUpdate.hoverHelp")} />
        </div>
      </Box>
    </GroupingBox>
  );
}
